import styled from 'styled-components';

const sizes = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};
export const devices = {
  mobileS: `(min-width: ${sizes.mobileS})`,
  mobileM: `(min-width: ${sizes.mobileM})`,
  mobileL: `(min-width: ${sizes.mobileL})`,
  tablet: `(min-width: ${sizes.tablet})`,
  laptop: `(min-width: ${sizes.laptop})`,
  laptopL: `(min-width: ${sizes.laptopL})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

export const FlexRowCentred = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
`;

export const FlexRowStart = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: 0.5rem 0;
`;

export const FlexRowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const FlexRowSpaceAround = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
`;

export const FlexRowSpaceEvenly = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
`;

export const FlexColumnCentred = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 0.25rem;
  align-items: center;
`;
export const FlexColumnCentredNoMargin = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0;
  align-items: center;
`;

export const PageTitle = styled.div`
  display: flex;
  justify-content: space-between;
  /* background-color: #d7d1d1; */
  /* padding: 0.5rem; */
  /* border-top: 1px solid black;
  border-bottom: 1px solid black; */
`;

export const Button = styled.button`
  border-radius: 5px;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  height: 1.5rem;
  min-width: 5rem;
  height: 2rem;
  font-size: 1rem;
  :disabled {
    border: 1px solid gray;
    background: #eef3f5;
    color: gray;
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 2rem;
`;

export const CourseWrapper = styled.h3`
  margin: 0.5rem 0 0;
`;

export const CentreHeading = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: bold;
`;

export const SectionWrapper = styled.div``;
